import { type OakStreamState } from "./types";

export function createInitialStreamState(initialLastEventId: string | undefined): OakStreamState {
  return {
    status: "closed",
    data: [],
    error: null,
    lastEventId: initialLastEventId,
    updatedAt: 0,
  };
}
